import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../assets/css/profile.css';
import socket from '../utils/socket';

export class InfoPerfil extends Component {
  logOut = () => {
    localStorage.clear();
    window.location.href = '/';
    socket.emit('disconnect', 'Logout');
  };

  render() {
    const { name, building, interior, apartament, phone, email, profileImage, role } = this.props;

    return (
      <div className="perfil">
        <div className="foto-perfil mx-auto">
          <div>
            <img src={profileImage} alt="Foto" className="avatar-img" />
          </div>
          <input type="file" name="fileupload" id="fileupload" />
        </div>

        <h2
          id="username"
          style={{
            wordWrap: 'break-word',
            lineHeight: 1.3,
          }}
        >
          {name}
        </h2>

        <h6 id="userrole">{role}</h6>

        {building && (
          <p className="info-row centered">
            <span className="form-icon material-icons">location_city</span>
            <span className="info-text">{building}</span>
          </p>
        )}

        {interior && interior !== "-" ? (
          <p className="info-row centered">
            <span className="form-icon material-icons">home</span>
            <span className="info-text">
              Interior {interior}{apartament && `, Apartamento ${apartament}`}
            </span>
          </p>
        ) : apartament ? (
          <p className="info-row centered">
            <span className="form-icon material-icons">home</span>
            <span className="info-text">Apartamento {apartament}</span>
          </p>
        ) : null}

        <p className="info-row centered">
          <span className="form-icon material-icons">phone</span>
          <span className="info-text">{phone}</span>
        </p>

        <p className="info-row centered">
          <span className="form-icon material-icons">email</span>
          <span className="info-text">{email}</span>
        </p>

        <a className='logout-link' onClick={this.logOut}>Cerrar sesión</a>
      </div>
    );
  }
}

InfoPerfil.propTypes = {
  name: PropTypes.string,
  building: PropTypes.string,
  interior: PropTypes.string,
  apartament: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  role: PropTypes.string,
  profileImage: PropTypes.string,
};

export default InfoPerfil;
